export function SettingsPage() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <h1 className="text-3xl font-bold mb-2">Настройки</h1>
        <p className="text-gray-500">Страница в разработке</p>
      </div>
    </div>
  );
}
